import React, { useState } from "react";
import { ManifestShell } from "./manifest/CosmicSky";

// A soft, personal password gate for the /manifest sub-site. The password ships
// in the JS bundle, so this only keeps casual visitors out — it's not real
// security (same posture as the board-game tracker's admin gate). Once unlocked
// on a device it's remembered in localStorage so it isn't asked every visit.

const MANIFEST_PASSWORD = "keyoniiscool";
const UNLOCK_KEY = "manifestUnlocked";

const ManifestGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(
    () => localStorage.getItem(UNLOCK_KEY) === "1"
  );
  const [guess, setGuess] = useState("");
  const [error, setError] = useState(false);

  if (unlocked) return children;

  const tryUnlock = () => {
    if (guess === MANIFEST_PASSWORD) {
      localStorage.setItem(UNLOCK_KEY, "1");
      setUnlocked(true);
    } else {
      setError(true);
    }
  };

  return (
    <ManifestShell>
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center backdrop-blur-sm">
          <div className="ms-float mb-4 text-4xl" aria-hidden>
            🔮
          </div>
          <p className="text-[11px] uppercase tracking-[0.35em] text-slate-400">
            universe &amp; co.
          </p>
          <h1 className="mt-2 font-serif text-2xl font-semibold">
            <span className="ms-shimmer">The night door</span>
          </h1>
          <p className="mt-2 text-sm text-slate-400">
            This little shop is just for you. Whisper the word to come in.
          </p>
          <input
            type="password"
            value={guess}
            autoFocus
            onChange={(e) => {
              setGuess(e.target.value);
              setError(false);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") tryUnlock();
            }}
            placeholder="The magic word"
            className="mt-6 w-full rounded-full border border-white/15 bg-[#05050e]/60 px-4 py-2.5 text-center text-sm text-slate-100 placeholder:text-slate-500 focus:border-amber-300/60 focus:outline-none"
          />
          {error && (
            <p className="mt-3 text-xs text-rose-300">
              The stars don't recognize that one. Try again.
            </p>
          )}
          <button
            type="button"
            onClick={tryUnlock}
            className="mt-5 w-full rounded-full border border-amber-300/70 bg-amber-300/15 px-6 py-2.5 text-sm font-medium text-amber-100 transition-colors hover:bg-amber-300/25"
          >
            Enter ✨
          </button>
        </div>
      </div>
    </ManifestShell>
  );
};

export default ManifestGate;
